import React from "react";
import { useTranslation } from "react-i18next";

const Philosophy = () => {
  const { t } = useTranslation("home");
  return (
    <div className="bg-gray-100 text-center py-4">
          <div className="text-2xl text-emerald-400 py-4 font-bold">{t("philosophy.title")}</div>
      <div className="text-sm py-4">
        {t("philosophy.intro")}
      </div>
    </div>
  );
};

export default Philosophy;
